/**
 * Words of the staff "Preview as a parent" entry (#5634). One home, so the program page and the
 * assistant's guide (featureGuide parent_booking_preview) cannot drift apart.
 */
export const PREVIEW_AS_PARENT_LABEL = 'Preview as a parent';
export const PREVIEW_AS_PARENT_HINT = 'Walk through sign-up as a new family. Nothing is booked.';
export const PREVIEW_AS_PARENT_LESSON_HINT = 'Walk through booking as a new family. No time is held or booked.';
export const PREVIEW_AS_PARENT_TRYOUT_HINT = 'Walk through tryout sign-up as a new family. No spot is held.';
export const PREVIEW_HIDDEN_TRYOUT_TEXT = "This tryout is hidden. Parents can't see it until you make it public.";
/** Private lesson confirm page in preview (#5634 step 2). */
export const PREVIEW_ADD_ATHLETE_TEXT = 'Parents add their own athletes here.';
export const PREVIEW_STANDING_CARD_TEXT = 'Parents add a card for weekly lessons here.';
